/* ═══════════════════════════════════════════════════════════════
   MAIN PRODUCT V2 - runtime
   Handles:
   - Gallery swap
   - Bundle pricing tier selection → updates ATC price + hidden qty
   - Easify MutationObserver: wraps native Easify inputs with our styling,
     bi-directional sync, progress tracking, required validation
   - Engraving drag + image picker + zoom
   - Sticky ATC show/hide + click validates
   - Judge.me integration with AI fallback
   ═══════════════════════════════════════════════════════════════ */
(function() {
  'use strict';

  const root = document.querySelector('.mpv2');
  if (!root) return;

  /* ─── GALLERY ─── */
  const galleryImgs = root.querySelectorAll('.mpv2__gallery-img');
  const galleryThumbs = root.querySelectorAll('.mpv2__gallery-thumb');
  galleryThumbs.forEach(t => t.addEventListener('click', () => {
    const idx = t.dataset.idx;
    galleryImgs.forEach(i => i.classList.toggle('active', i.dataset.idx === idx));
    galleryThumbs.forEach(tt => tt.classList.toggle('active', tt.dataset.idx === idx));
  }));

  /* ─── BUNDLE PRICING ─── */
  const basePrice = parseFloat(document.querySelector('[data-bind="price"]')?.textContent.replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
  const qtyInput = document.getElementById('mpv2-quantity');
  root.querySelectorAll('.mpv2__bundle-tier').forEach(tier => {
    tier.addEventListener('click', () => {
      root.querySelectorAll('.mpv2__bundle-tier').forEach(t => t.classList.remove('active'));
      tier.classList.add('active');
      const qty = parseInt(tier.dataset.qty);
      const discount = parseInt(tier.dataset.discount || 0);
      const perItem = basePrice * (1 - discount / 100);
      const total = (perItem * qty).toFixed(2);
      const currency = document.querySelector('[data-bind="price"]')?.textContent.replace(/[\d.,\s]/g, '').trim() || '€';
      const priceText = `${total} ${currency}${qty > 1 ? ` (${qty} бр)` : ''}`;
      root.querySelectorAll('[data-bind="atc-price"]').forEach(el => el.textContent = priceText);
      if (qtyInput) qtyInput.value = qty;
    });
  });

  /* ─── EASIFY MutationObserver BRIDGE ─── */
  const easifyWrap = document.getElementById('mpv2-easify-wrap');
  const easifyMount = document.getElementById('easify-product-options');
  const progressBar = document.getElementById('mpv2-easify-progress');
  const progressLabel = document.getElementById('mpv2-easify-progress-label');

  function wrapEasifyInput(input) {
    if (input.closest('.mpv2__easify-field')) return; // already wrapped

    const name = input.getAttribute('name') || '';
    const propName = (name.match(/properties\[(.+?)\]/) || [])[1] || '';
    const label = input.closest('label')?.querySelector('span, .tpo_option_label')?.textContent.trim() || propName || 'Поле';
    const required = input.hasAttribute('required') || input.dataset.required !== undefined;
    const maxLen = input.maxLength > 0 ? input.maxLength : null;

    const wrap = document.createElement('div');
    wrap.className = 'mpv2__easify-field' + (required ? ' required' : '');
    wrap.dataset.easifyBind = propName;

    const iconSpan = document.createElement('span');
    iconSpan.className = 'mpv2__easify-icon';
    iconSpan.innerHTML = '<svg class="mpv2-icon mpv2-icon--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M12 2a10 10 0 1 0 10 10"/></svg>';

    const labelSpan = document.createElement('span');
    labelSpan.className = 'mpv2__easify-field-label';
    labelSpan.textContent = label;

    const clone = input.cloneNode(true);
    clone.className = 'mpv2__easify-input mpv2__easify-sync';
    clone.dataset.easifySource = 'true';

    // Hide the original, keep it in DOM for form submission - sync value on change
    input.style.display = 'none';
    clone.addEventListener('input', () => {
      input.value = clone.value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateProgress();
      updateCounter();
    });

    wrap.appendChild(iconSpan);
    wrap.appendChild(labelSpan);
    wrap.appendChild(clone);

    if (maxLen) {
      const counter = document.createElement('span');
      counter.className = 'mpv2__easify-counter';
      counter.innerHTML = `<span class="mpv2__easify-counter-num">0</span>/${maxLen}`;
      wrap.appendChild(counter);
      const updateCounter = () => {
        counter.querySelector('.mpv2__easify-counter-num').textContent = clone.value.length;
      };
      clone.addEventListener('input', updateCounter);
    } else {
      var updateCounter = () => {};
    }

    easifyWrap.insertBefore(wrap, easifyMount);

    // Mirror engraving to live preview if name matches known fields
    const engravingPreview = document.getElementById('mpv2-engraving-text');
    const engravingInput = document.getElementById('mpv2-engraving-input');
    if (engravingPreview && ['Име', 'Name', 'Дата', 'Date', 'Послание', 'Message'].includes(propName)) {
      clone.addEventListener('input', () => {
        const vals = Array.from(document.querySelectorAll('.mpv2__easify-sync'))
          .map(i => i.value.trim())
          .filter(Boolean);
        if (vals.length > 0) {
          const combined = vals.slice(0, 2).join(' · ');
          engravingPreview.textContent = combined;
          if (engravingInput) engravingInput.value = combined;
        }
      });
    }
  }

  function wrapCustomFields() {
    root.querySelectorAll('[data-custom-field]').forEach(input => {
      const wrap = input.closest('.mpv2__easify-field');
      if (!wrap) return;
      const counter = wrap.querySelector('[data-count-for-id]');
      input.addEventListener('input', () => {
        if (counter) counter.textContent = input.value.length;
        updateProgress();
      });
    });
  }

  function updateProgress() {
    const all = root.querySelectorAll('.mpv2__easify-sync, [data-custom-field]');
    const filled = Array.from(all).filter(i => i.value.trim().length > 0).length;
    if (progressBar) progressBar.style.width = (all.length ? (filled / all.length) * 100 : 0) + '%';
    if (progressLabel) progressLabel.textContent = `${filled} / ${all.length} полета`;
  }

  if (easifyMount) {
    const observer = new MutationObserver(() => {
      easifyMount.querySelectorAll('input:not([type="hidden"]):not([type="file"]), textarea, select').forEach(wrapEasifyInput);
      updateProgress();
    });
    observer.observe(easifyMount, { childList: true, subtree: true });

    // Initial pass
    setTimeout(() => {
      easifyMount.querySelectorAll('input:not([type="hidden"]):not([type="file"]), textarea, select').forEach(wrapEasifyInput);
      updateProgress();
    }, 500);
  }
  wrapCustomFields();
  updateProgress();

  /* ─── ENGRAVING LIVE PREVIEW: drag + image picker + zoom ─── */
  const engDrag = document.getElementById('mpv2-engraving-drag');
  const previewCanvas = document.getElementById('mpv2-preview-canvas');
  const engInput = document.getElementById('mpv2-engraving-input');
  const engPreview = document.getElementById('mpv2-engraving-text');

  if (engInput && engPreview) {
    engInput.addEventListener('input', () => {
      engPreview.textContent = engInput.value || ' ';
    });
  }

  if (engDrag && previewCanvas) {
    let dragging = false, startX, startY, origLeft, origTop;
    const startDrag = (cx, cy) => {
      dragging = true;
      engDrag.classList.add('dragging');
      const r = previewCanvas.getBoundingClientRect();
      const er = engDrag.getBoundingClientRect();
      startX = cx; startY = cy;
      origLeft = ((er.left + er.width / 2) - r.left) / r.width * 100;
      origTop = ((er.top + er.height / 2) - r.top) / r.height * 100;
      engDrag.style.transform = 'translate(-50%, -50%)';
    };
    const move = (cx, cy) => {
      if (!dragging) return;
      const r = previewCanvas.getBoundingClientRect();
      const dx = ((cx - startX) / r.width) * 100;
      const dy = ((cy - startY) / r.height) * 100;
      engDrag.style.left = Math.max(15, Math.min(85, origLeft + dx)) + '%';
      engDrag.style.top = Math.max(10, Math.min(90, origTop + dy)) + '%';
    };
    const end = () => { dragging = false; engDrag.classList.remove('dragging'); };
    engDrag.addEventListener('mousedown', e => { e.preventDefault(); startDrag(e.clientX, e.clientY); });
    document.addEventListener('mousemove', e => move(e.clientX, e.clientY));
    document.addEventListener('mouseup', end);
    engDrag.addEventListener('touchstart', e => { const t = e.touches[0]; startDrag(t.clientX, t.clientY); }, { passive: true });
    document.addEventListener('touchmove', e => { if (dragging) { const t = e.touches[0]; move(t.clientX, t.clientY); e.preventDefault(); } }, { passive: false });
    document.addEventListener('touchend', end);
  }

  /* FONT PICKER */
  const fontSel = document.getElementById('mpv2-font');
  if (fontSel && engPreview) {
    fontSel.addEventListener('change', () => {
      engPreview.style.fontFamily = fontSel.value;
    });
  }

  /* TEXT SIZE */
  const sizeRange = document.getElementById('mpv2-text-size');
  if (sizeRange && engPreview) {
    sizeRange.addEventListener('input', () => {
      engPreview.style.fontSize = sizeRange.value + 'px';
    });
  }

  /* IMAGE ZOOM */
  const previewImg = document.getElementById('mpv2-preview-img');
  const zoomRange = document.getElementById('mpv2-zoom');
  if (zoomRange && previewImg) {
    zoomRange.addEventListener('input', () => previewImg.style.transform = `scale(${zoomRange.value / 100})`);
  }

  /* RESET */
  const resetBtn = document.getElementById('mpv2-reset-pos');
  if (resetBtn) resetBtn.addEventListener('click', () => {
    if (engDrag) { engDrag.style.left = '50%'; engDrag.style.top = '75%'; }
    if (engPreview) { engPreview.style.fontSize = ''; engPreview.style.fontFamily = ''; }
    if (previewImg) previewImg.style.transform = 'scale(1)';
    if (zoomRange) zoomRange.value = 100;
    if (sizeRange) sizeRange.value = 36;
    if (fontSel) fontSel.value = fontSel.options[0].value;
  });

  /* ─── FAQ ─── */
  root.querySelectorAll('.mpv2__faq-q').forEach(q => q.addEventListener('click', () => q.parentElement.classList.toggle('open')));

  /* ─── STICKY ATC + validate ─── */
  const sticky = document.getElementById('mpv2-sticky-atc');
  const hero = root.querySelector('.mpv2__hero');
  const atcBtn = document.getElementById('mpv2-atc');
  const easifyZone = document.getElementById('mpv2-easify-mask');

  if (sticky && hero) {
    window.addEventListener('scroll', () => {
      const bottom = hero.getBoundingClientRect().bottom;
      sticky.classList.toggle('show', bottom < 0);
    }, { passive: true });
  }

  function validateAndScroll() {
    const requiredEmpty = Array.from(root.querySelectorAll('[data-required], [required]'))
      .filter(i => i.offsetParent !== null) // visible only
      .some(i => !i.value.trim());
    if (requiredEmpty) {
      easifyZone?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => {
        easifyZone?.classList.add('flash');
        setTimeout(() => easifyZone?.classList.remove('flash'), 1400);
      }, 400);
      return false;
    }
    return true;
  }

  sticky?.addEventListener('click', (e) => {
    if (!validateAndScroll()) return;
    // All valid → submit the real form
    atcBtn?.click();
  });
  atcBtn?.addEventListener('click', (e) => {
    if (!validateAndScroll()) { e.preventDefault(); return; }
  });

  /* ─── JUDGE.ME HOOK ─── */
  const reviewsSummary = root.querySelector('[data-reviews-threshold]');
  const aiReviewsGrid = root.querySelector('[data-ai-reviews]');
  const judgemeMount = root.querySelector('[data-judgeme-widget]');

  if (reviewsSummary) {
    const threshold = parseInt(reviewsSummary.dataset.reviewsThreshold);

    // Option A: Poll Judge.me JSON API on the page
    // Requires your Judge.me public key and product_id
    // window.jdgm?.REVIEWS_PUBLIC_ID and product.id are available globally
    if (window.jdgm && window.jdgm.REVIEWS_PUBLIC_ID) {
      const publicId = window.jdgm.REVIEWS_PUBLIC_ID;
      const productId = document.querySelector('[data-judgeme-product-id]')?.dataset.judgemeProductId;
      if (productId) {
        fetch(`https://judge.me/api/v1/reviews?api_token=${publicId}&shop_domain=${window.Shopify?.shop}&product_id=${productId}&per_page=9`)
          .then(r => r.json())
          .then(data => {
            const count = data.reviews?.length || 0;
            if (count >= threshold) {
              // Replace AI reviews with real ones
              renderRealReviews(data.reviews);
              if (aiReviewsGrid) aiReviewsGrid.style.display = 'none';
              if (judgemeMount) judgemeMount.style.display = 'block';
              // Update summary
              const avg = data.reviews.reduce((s, r) => s + r.rating, 0) / count;
              root.querySelectorAll('[data-bind="reviews-score"], [data-bind="reviews-score-large"]')
                .forEach(el => el.textContent = avg.toFixed(1));
              root.querySelectorAll('[data-bind="reviews-count"], [data-bind="reviews-count-large"]')
                .forEach(el => el.textContent = `${count} отзива`);
            }
          })
          .catch(() => {});
      }
    }

    // Option B: Read Judge.me DOM if their widget is embedded elsewhere
    const jdgmCount = document.querySelector('.jdgm-prev-badge__text')?.textContent;
    const jdgmRating = document.querySelector('.jdgm-prev-badge')?.dataset.averageRating;
    if (jdgmCount && jdgmRating) {
      const countNum = parseInt(jdgmCount);
      if (countNum >= threshold) {
        root.querySelectorAll('[data-bind="reviews-score"], [data-bind="reviews-score-large"]').forEach(el => el.textContent = jdgmRating);
        root.querySelectorAll('[data-bind="reviews-count"], [data-bind="reviews-count-large"]').forEach(el => el.textContent = `${countNum} отзива`);
      }
    }
  }

  function renderRealReviews(reviews) {
    if (!judgemeMount) return;
    const container = document.createElement('div');
    container.className = 'mpv2__reviews-grid';
    reviews.slice(0, 9).forEach(rev => {
      const card = document.createElement('div');
      card.className = 'mpv2__review';
      card.innerHTML = `
        <div class="mpv2__review-stars">${'<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>'.repeat(rev.rating)}</div>
        <p class="mpv2__review-text">${rev.body?.replace(/</g, '&lt;') || ''}</p>
        <div class="mpv2__review-author">
          <div class="mpv2__review-avatar">${(rev.reviewer?.name || '?')[0]}</div>
          <div>
            <div class="mpv2__review-name">${rev.reviewer?.name || 'Анонимен'}</div>
            <div class="mpv2__review-meta">${new Date(rev.created_at).toLocaleDateString('bg-BG')}</div>
          </div>
        </div>`;
      container.appendChild(card);
    });
    judgemeMount.innerHTML = '';
    judgemeMount.appendChild(container);
  }

  /* ─── IntersectionObserver for reveal ─── */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('mpv2-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  root.querySelectorAll('.mpv2__section, .mpv2__hero').forEach(el => io.observe(el));
})();
